import { Theme, darken } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';
import { gradientBorder } from '../../../../themes/v2/theme.base';

interface StyleProps {
  isSuggestedOrder: boolean;
}

const useOrderActiveMenuStyles = makeStyles<StyleProps>()((theme: Theme, { isSuggestedOrder }) => ({
  badge: {
    transform: 'translate(-15px, -16px)',
    '& .MuiBadge-badge': {
      [theme.breakpoints.down('sm')]: {
        fontSize: '10px',
        transform: 'translate(22px, -10px)',
      },
    },
  },
  typography: {
    width: '100%',
  },
  button: {
    '& .MuiButton-startIcon': {
      ...(isSuggestedOrder && { color: theme.palette.custom.status.closed }),
    },
    '&&[data-active="true"]': {
      background: gradientBorder(
        theme.palette.custom.layout.shell.buttonSelected,
        theme.palette.custom.gradients.secondaryButton,
      ),
      '&:hover': {
        background: gradientBorder(
          darken(theme.palette.custom.layout.shell.buttonSelected, 0.05),
          theme.palette.custom.gradients.secondaryButtonHover,
        ),
      },
      '&:active': {
        background: gradientBorder(
          darken(theme.palette.custom.layout.shell.buttonSelected, 0.1),
          theme.palette.custom.gradients.secondaryButtonHover,
        ),
      },
    },
  },
}));

export default useOrderActiveMenuStyles;
